import {useState} from 'react'
import {useAuth} from '../../../modules/auth'

export function InterpreterJoinNameHint() {
  const {currentUser} = useAuth()
  const result = currentUser?.result
  const [copied, setCopied] = useState(false)

  if (result?.userType !== 'INTERPRETER') return null
  const userId = result?.userId?.trim()
  if (!userId) return null

  const displayName = `${result?.firstName ?? ''} ${result?.lastName ?? ''}`.trim()
  const joinName = displayName ? `${displayName}-${userId}` : `-${userId}`

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(joinName)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      
    }
  }

  return (
    <div className='row mb-3'>
      <div className='col-12'>
        <div
          className='d-flex align-items-start p-3 rounded'
          style={{backgroundColor: '#F1FAFF', border: '1px solid #B8E7FF'}}
        >
          <i className='fa-solid fa-robot me-3 mt-1' style={{color: '#009EF7'}} />
          <div className='flex-grow-1'>
            <div className='fw-bold text-black mb-1'>
              Join with this name so your attendance is recorded automatically
            </div>
            <div className='text-gray-700 fs-7 mb-2'>
              When you open the meeting link, set your display name to:
            </div>
            <div className='d-flex align-items-center flex-wrap gap-2'>
              <code
                className='fs-6 px-2 py-1 rounded'
                style={{backgroundColor: '#fff', border: '1px solid #B8E7FF', color: '#181C32'}}
              >
                {joinName}
              </code>
              <button
                type='button'
                className='btn btn-sm btn-light-primary py-1 px-3'
                onClick={copy}
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
